import { actionTypes as asyncTypes } from "async-ops";
import { cloneDeep } from "lodash";
import {
  updateStateAfterWidgetOptionChange,
  isMdaeWidgetOptionChangeEvent,
} from "../../common_components/mdae-framework";
export const TOGGLE_REFRESH_TOKEN_FAILED_POPUP =
  "TOGGLE_REFRESH_TOKEN_FAILED_POPUP";
export const TOGGLE_INACTIVE_SESSION_WARNING_POPUP =
  "TOGGLE_INACTIVE_SESSION_WARNING_POPUP";
export const TOGGLE_SECURITY_NOTICE_POPUP = "TOGGLE_SECURITY_NOTICE_POPUP";
export const TOGGLE_CPT_LICENSING_POPUP = "TOGGLE_CPT_LICENSING_POPUP";
export const TOGGLE_COPY_TEXT_TOOLTIP = "TOGGLE_COPY_TEXT_TOOLTIP";
export const IS_APP_LOADED = "IS_APP_LOADED";
const initialState = {
  isLoading: false,
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_REFRESH_TOKEN_FAILED_POPUP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const refreshTokenPopupConfig = newState.refreshTokenPopupConfig
          ? newState.refreshTokenPopupConfig
          : {};
        for (let prop in action.data) {
          refreshTokenPopupConfig[prop] = action.data[prop];
        }
        newState = {
          ...newState,
          refreshTokenPopupConfig: refreshTokenPopupConfig,
        };
      }
      return newState;
    case TOGGLE_INACTIVE_SESSION_WARNING_POPUP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const inactiveSessionWarningPopupConfig = newState.inactiveSessionWarningPopupConfig
          ? newState.inactiveSessionWarningPopupConfig
          : {};
        for (let prop in action.data) {
          inactiveSessionWarningPopupConfig[prop] = action.data[prop];
        }
        newState = {
          ...newState,
          inactiveSessionWarningPopupConfig: inactiveSessionWarningPopupConfig,
        };
      }
      return newState;
    case TOGGLE_SECURITY_NOTICE_POPUP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const securityNoticePopupConfig = newState.securityNoticePopupConfig
          ? newState.securityNoticePopupConfig
          : {};
        for (let prop in action.data) {
          securityNoticePopupConfig[prop] = action.data[prop];
        }
        newState = {
          ...newState,
          securityNoticePopupConfig: securityNoticePopupConfig,
        };
      }
      return newState;
    case TOGGLE_CPT_LICENSING_POPUP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const cptLicensingPopupConfig = newState.cptLicensingPopupConfig
          ? newState.cptLicensingPopupConfig
          : {};
        for (let prop in action.data) {
          cptLicensingPopupConfig[prop] = action.data[prop];
        }
        newState = {
          ...newState,
          securityNoticePopupConfig: cptLicensingPopupConfig,
        };
      }
      return newState;
    case TOGGLE_COPY_TEXT_TOOLTIP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const copyTextTooltipConfig = newState.copyTextTooltipConfig
          ? newState.copyTextTooltipConfig
          : {};
        for (let prop in action.data) {
          copyTextTooltipConfig[prop] = action.data[prop];
        }
        newState = {
          ...newState,
          copyTextTooltipConfig,
        };
      }
      return newState;
    case IS_APP_LOADED:
      return { ...state, isAppLoaded: true };
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      return state;
    default:
      return state;
  }
}
